import { observer } from 'mobx-react';
import FilterTemplate from '../../FilterTemplate';
import { allOptions } from '../../FilterTemplate/Types';
import Store from '../../Store';
import { ExperiencesResource, Toggle } from '../../Types';
import { useFilterStoreContext } from '../FilterStores';
import UnLicensedToggle from './UnLicensedToggle';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  store: Store;
  experiences: ExperiencesResource;
  toggle: Toggle;
  setToggle: (arg: Toggle) => void;
}

function ExperiencesFilter({ experiences, toggle, setToggle }: Props) {
  const {
    productTypeFilterOptions,
    durationFilterOptions,
    competencyFilterOptions,
    schoolPartnerFilterOptions,
    availableLanguagesFilterOptions,
  } = experiences.payload;

  return (
    <>
      {useFilterStoreContext()
        .map(
          ({
            competencyFilterStore,
            durationFilterStore,
            languageFilterStore,
            productTypeFilterStore,
            schoolPartnerFilterStore,
          }) => (
            <>
              <FilterTemplate
                filterStore={productTypeFilterStore}
                options={allOptions(productTypeFilterOptions)}
                filterName="Program Type"
                zIndex={'z-[15]'}
              />
              <FilterTemplate
                filterStore={competencyFilterStore}
                options={allOptions(competencyFilterOptions)}
                filterName="Competency"
                zIndex={'z-[14]'}
              />
              <FilterTemplate
                filterStore={schoolPartnerFilterStore}
                options={allOptions(schoolPartnerFilterOptions)}
                filterName="School Partner"
                zIndex={'z-[13]'}
              />
              <FilterTemplate
                filterStore={languageFilterStore}
                options={allOptions(availableLanguagesFilterOptions)}
                filterName="Language"
                zIndex={'z-[12]'}
              />
              <FilterTemplate
                filterStore={durationFilterStore}
                options={allOptions(durationFilterOptions)}
                filterName="Time Commitment"
                zIndex={'z-[11]'}
              />
            </>
          ),
        )
        .getOrElse(emptyFragment)}
      <UnLicensedToggle experiences={experiences} toggle={toggle} setToggle={setToggle} />
    </>
  );
}

export default observer(ExperiencesFilter);
